import React, { Component } from "react";
import "./Footer.css";

class Footer extends Component {
  render() {
    return (
      <div className="footer">
        <div className="footer-text">
          © 2022 Fannie Mae
        </div>
      </div>
    );
  }
}

export default Footer;
